// mobile phone resolution

var dataSource = window.dataSource;

function createElement(domType, attributes) {
  var dom = document.createElement(domType);
  if (!attributes) return dom;
  for (var attr in attributes) {
    dom.setAttribute(attr, attributes[attr]);
  }
  return dom;
}

// body padding-bottom value is equal as footer's height value
const initBodyPaddingBottom = () => {
  /*    const domFooter = document.querySelector(".footer");
    const domBody = document.querySelector("body");
    if(!domFooter || !domBody) return;
    const height = (getComputedStyle(domFooter).height) || 0;
    domBody.setAttribute("style", `padding-bottom: ${height}`);*/

  const height = $(".footerWrapper").height() || 0;
  $("body").css({ paddingBottom: height });
};

window.onload = window.onresize = initBodyPaddingBottom;



/** WEBPACK FOOTER **
 ** ./src/website.js
 **/